"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var rdf_string_1 = require("rdf-string");
/**
 * A comunica Project Query Operation Actor.
 */


var ActorQueryOperationProject =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationProject, _bus_query_operation_);

  function ActorQueryOperationProject(args) {
    _classCallCheck(this, ActorQueryOperationProject);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationProject).call(this, args, 'project'));
  }

  _createClass(ActorQueryOperationProject, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pattern, context) {
        var output, variables, deleteVariables, missingVariables, bindingsStream;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = bus_query_operation_1.ActorQueryOperation;
                _context2.next = 3;
                return this.mediatorQueryOperation.mediate({
                  operation: pattern.input,
                  context: context
                });

              case 3:
                _context2.t1 = _context2.sent;
                output = _context2.t0.getSafeBindings.call(_context2.t0, _context2.t1);
                // Find all variables that should be deleted from the input stream
                // and all variables that are not bound in the input stream.
                variables = pattern.variables.map(rdf_string_1.termToString);
                deleteVariables = output.variables.filter(function (variable) {
                  return variables.indexOf(variable) < 0;
                });
                missingVariables = variables.filter(function (variable) {
                  return output.variables.indexOf(variable) < 0;
                }); // Make sure the project variables are the only variables that are present in the bindings.

                bindingsStream = !deleteVariables.length && !missingVariables.length ? output.bindingsStream : output.bindingsStream.map(function (binding) {
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = deleteVariables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var deleteVariable = _step.value;
                      binding = binding.delete(deleteVariable);
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }

                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    for (var _iterator2 = missingVariables[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      var missingVariable = _step2.value;
                      binding = binding.set(missingVariable, null);
                    }
                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }

                  return binding;
                });
                return _context2.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  metadata: output.metadata,
                  variables: variables
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return ActorQueryOperationProject;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationProject = ActorQueryOperationProject;